function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { key2pos, createEl, posToTranslate as posToTranslateFromBounds, translate } from './util.js';
import { whitePov } from './board.js';
// ported from https://github.com/lichess-org/lichobile/blob/master/src/chessground/render.ts
// in case of bugs, blame @veloce
export function render(s) {
  var asWhite = whitePov(s),
    posToTranslate = posToTranslateFromBounds(s.dom.bounds()),
    boardEl = s.dom.elements.board,
    pieces = s.pieces,
    curAnim = s.animation.current,
    anims = curAnim ? curAnim.plan.anims : new Map(),
    fadings = curAnim ? curAnim.plan.fadings : new Map(),
    curDrag = s.draggable.current,
    squares = computeSquareClasses(s),
    samePieces = new Set(),
    sameSquares = new Set(),
    movedPieces = new Map(),
    movedSquares = new Map(); // by class name
  var k, el, pieceAtKey, elPieceName, anim, fading, pMvdset, pMvd, sMvdset, sMvd;
  // walk over all board dom elements, apply animations and flag moved pieces
  el = boardEl.firstChild;
  while (el) {
    k = el.cgKey;
    if (isPieceNode(el)) {
      pieceAtKey = pieces.get(k);
      anim = anims.get(k);
      fading = fadings.get(k);
      elPieceName = el.cgPiece;
      // if piece not being dragged anymore, remove dragging style
      if (el.cgDragging && (!curDrag || curDrag.orig !== k)) {
        el.classList.remove('dragging');
        translate(el, posToTranslate(key2pos(k), asWhite));
        el.cgDragging = false;
      }
      // remove fading class if it still remains
      if (!fading && el.cgFading) {
        el.cgFading = false;
        el.classList.remove('fading');
      }
      // there is now a piece at this dom key
      if (pieceAtKey) {
        // continue animation if already animating and same piece
        // (otherwise it could animate a captured piece)
        if (anim && el.cgAnimating && elPieceName === pieceNameOf(pieceAtKey)) {
          var pos = key2pos(k);
          pos[0] += anim[2];
          pos[1] += anim[3];
          el.classList.add('anim');
          translate(el, posToTranslate(pos, asWhite));
        } else if (el.cgAnimating) {
          el.cgAnimating = false;
          el.classList.remove('anim');
          translate(el, posToTranslate(key2pos(k), asWhite));
          if (s.addPieceZIndex) el.style.zIndex = posZIndex(key2pos(k), asWhite);
        }
        // same piece: flag as same
        if (elPieceName === pieceNameOf(pieceAtKey) && (!fading || !el.cgFading)) {
          samePieces.add(k);
        }
        // different piece: flag as moved unless it is a fading piece
        else {
          if (fading && elPieceName === pieceNameOf(fading)) {
            el.classList.add('fading');
            el.cgFading = true;
          } else {
            appendValue(movedPieces, elPieceName, el);
          }
        }
      }
      // no piece: flag as moved
      else {
        appendValue(movedPieces, elPieceName, el);
      }
    } else if (isSquareNode(el)) {
      var cn = el.className;
      if (squares.get(k) === cn) sameSquares.add(k);else appendValue(movedSquares, cn, el);
    }
    el = el.nextSibling;
  }
  // walk over all squares in current set, apply dom changes to moved squares
  // or append new squares
  var _iterator = _createForOfIteratorHelper(squares),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref = _step.value;
      var _ref2 = _slicedToArray(_ref, 2);
      var sk = _ref2[0];
      var className = _ref2[1];
      if (!sameSquares.has(sk)) {
        sMvdset = movedSquares.get(className);
        sMvd = sMvdset && sMvdset.pop();
        var translation = posToTranslate(key2pos(sk), asWhite);
        if (sMvd) {
          sMvd.cgKey = sk;
          translate(sMvd, translation);
        } else {
          var squareNode = createEl('square', className);
          squareNode.cgKey = sk;
          translate(squareNode, translation);
          boardEl.insertBefore(squareNode, boardEl.firstChild);
        }
      }
    }
    // walk over all pieces in current set, apply dom changes to moved pieces
    // or append new pieces
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(pieces),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref3 = _step2.value;
      var _ref4 = _slicedToArray(_ref3, 2);
      var _k = _ref4[0];
      var p = _ref4[1];
      anim = anims.get(_k);
      if (!samePieces.has(_k)) {
        pMvdset = movedPieces.get(pieceNameOf(p));
        pMvd = pMvdset && pMvdset.pop();
        // a same piece was moved
        if (pMvd) {
          // apply dom changes
          pMvd.cgKey = _k;
          if (pMvd.cgFading) {
            pMvd.classList.remove('fading');
            pMvd.cgFading = false;
          }
          var _pos = key2pos(_k);
          if (s.addPieceZIndex) pMvd.style.zIndex = posZIndex(_pos, asWhite);
          if (anim) {
            pMvd.cgAnimating = true;
            pMvd.classList.add('anim');
            _pos[0] += anim[2];
            _pos[1] += anim[3];
          }
          translate(pMvd, posToTranslate(_pos, asWhite));
        }
        // no piece in moved obj: insert the new piece
        // assumes the new piece is not being dragged
        else {
          var pieceName = pieceNameOf(p),
            pieceNode = createEl('piece', pieceName),
            _pos2 = key2pos(_k);
          pieceNode.cgPiece = pieceName;
          pieceNode.cgKey = _k;
          if (anim) {
            pieceNode.cgAnimating = true;
            _pos2[0] += anim[2];
            _pos2[1] += anim[3];
          }
          translate(pieceNode, posToTranslate(_pos2, asWhite));
          if (s.addPieceZIndex) pieceNode.style.zIndex = posZIndex(_pos2, asWhite);
          boardEl.appendChild(pieceNode);
        }
      }
    }
    // remove any element that remains in the moved sets
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(movedPieces.values()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var nodes = _step3.value;
      removeNodes(s, nodes);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var _iterator4 = _createForOfIteratorHelper(movedSquares.values()),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _nodes = _step4.value;
      removeNodes(s, _nodes);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
export function renderResized(s) {
  var asWhite = whitePov(s),
    posToTranslate = posToTranslateFromBounds(s.dom.bounds());
  var el = s.dom.elements.board.firstChild;
  while (el) {
    if (isPieceNode(el) && !el.cgAnimating || isSquareNode(el)) {
      translate(el, posToTranslate(key2pos(el.cgKey), asWhite));
    }
    el = el.nextSibling;
  }
}
export function updateBounds(s) {
  var _a, _b;
  var bounds = s.dom.elements.wrap.getBoundingClientRect();
  var container = s.dom.elements.container;
  var ratio = bounds.height / bounds.width;
  var width = Math.floor(bounds.width * window.devicePixelRatio / 8) * 8 / window.devicePixelRatio;
  var height = width * ratio;
  container.style.width = width + 'px';
  container.style.height = height + 'px';
  s.dom.bounds.clear();
  (_a = s.addDimensionsCssVarsTo) === null || _a === void 0 ? void 0 : _a.style.setProperty('---cg-width', width + 'px');
  (_b = s.addDimensionsCssVarsTo) === null || _b === void 0 ? void 0 : _b.style.setProperty('---cg-height', height + 'px');
}
var isPieceNode = function isPieceNode(el) {
  return el.tagName === 'PIECE';
};
var isSquareNode = function isSquareNode(el) {
  return el.tagName === 'SQUARE';
};
function removeNodes(s, nodes) {
  var _iterator5 = _createForOfIteratorHelper(nodes),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var node = _step5.value;
      s.dom.elements.board.removeChild(node);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
}
function posZIndex(pos, asWhite) {
  var minZ = 3;
  var rank = pos[1];
  var z = asWhite ? minZ + 7 - rank : minZ + rank;
  return "".concat(z);
}
var pieceNameOf = function pieceNameOf(piece) {
  return "".concat(piece.color, " ").concat(piece.role);
};
function computeSquareClasses(s) {
  var _a, _b, _c;
  var squares = new Map();
  if (s.lastMove && s.highlight.lastMove) {
    var _iterator6 = _createForOfIteratorHelper(s.lastMove),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var k = _step6.value;
        addSquare(squares, k, 'last-move');
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  if (s.check && s.highlight.check) addSquare(squares, s.check, 'check');
  if (s.selected) {
    addSquare(squares, s.selected, 'selected');
    if (s.movable.showDests) {
      var dests = (_a = s.movable.dests) === null || _a === void 0 ? void 0 : _a.get(s.selected);
      if (dests) {
        var _iterator7 = _createForOfIteratorHelper(dests),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _k2 = _step7.value;
            addSquare(squares, _k2, 'move-dest' + (s.pieces.has(_k2) ? ' oc' : ''));
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
      var pDests = (_c = (_b = s.premovable.customDests) === null || _b === void 0 ? void 0 : _b.get(s.selected)) !== null && _c !== void 0 ? _c : s.premovable.dests;
      if (pDests) {
        var _iterator8 = _createForOfIteratorHelper(pDests),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _k3 = _step8.value;
            addSquare(squares, _k3, 'premove-dest' + (s.pieces.has(_k3) ? ' oc' : ''));
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }
  }
  var premove = s.premovable.current;
  if (premove) {
    var _iterator9 = _createForOfIteratorHelper(premove),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _k4 = _step9.value;
        addSquare(squares, _k4, 'current-premove');
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  } else if (s.predroppable.current) addSquare(squares, s.predroppable.current.key, 'current-premove');
  var o = s.exploding;
  if (o) {
    var _iterator10 = _createForOfIteratorHelper(o.keys),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var _k5 = _step10.value;
        addSquare(squares, _k5, 'exploding' + o.stage);
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }
  if (s.highlight.custom) {
    s.highlight.custom.forEach(function (v, k) {
      addSquare(squares, k, v);
    });
  }
  return squares;
}
function addSquare(squares, key, klass) {
  var classes = squares.get(key);
  if (classes) squares.set(key, "".concat(classes, " ").concat(klass));else squares.set(key, klass);
}
function appendValue(map, key, value) {
  var arr = map.get(key);
  if (arr) arr.push(value);else map.set(key, [value]);
}